import GetIcon from "../../../../utils/Icon";


const FingerprintInput = ({ field, setFieldValue, values }) => {
  return (
    <div className="border-2 border-dashed border-gray-300 rounded-lg p-4 text-center" onClick={() => { field.Capture(setFieldValue) }}>
      {values.finger_data.base64 !== "" ? (
        <div className="relative">
          <img src={`data:image/png;base64,${values.finger_data.base64}`} alt={field.label} className='h-64 w-54 mx-auto rounded-lg object-fit' />
        </div>
      ) : (
        <div className='h-36 w-full flex flex-col items-center justify-center rounded-lg'>
          <span className="w-9 h-9 bg-gray-200 rounded-full flex justify-center items-center p-1.5 mt-4 mb-2">
            <GetIcon iconName="IoImageOutline" size={32} design="text-primary" />
          </span>
          <h1 className="mb-3 text-gray-500 font-inter">click to add Fingerprint</h1>
          <label htmlFor={field.name} className="px-4 py-2 bg-gray-200  text-primary rounded-lg cursor-pointer">
            Add {field.label}
          </label>
        </div>
      )}
    </div>
  );
};

export default FingerprintInput;